/* eslint-disable no-console */
import {Row, Col, Typography} from 'antd';
import React, {useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import FullLogo from '../../assets/FullLogo.svg';
import GreenRightSideImg from '../../assets/GreenerEarth.png';
import QT66Img from '../../assets/qt66.png';

import ChangePasswordScreen from './components/changePasswordScreen';
import ErrorScreen from './components/errorScreen';
import OtpVerification from './components/otpScreen';
import ValidateEmailScreen from './components/validateEmailScreen';

const {Title} = Typography;

const ForgotPasswordPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [searchParams] = useSearchParams();
  const callback = searchParams.get('callback');
  let callbackUrl = '/';
  if (callback) {
    try {
      callbackUrl = atob(callback);
    } catch (error) {}
  }

  const [step, setStep] = useState('initial');
  const onEmailStepFinished = (email: string) => {
    setStep('otp');
    setEmail(email);
  };

  const handleOtpVerify = (otp: string) => {
    setOtp(otp);
    setStep('finished');
  };

  const handleChangeEmail = () => {
    setStep('initial');
  };

  const renderFormStep = () => {
    switch (step) {
      case 'initial':
        return (
          <ValidateEmailScreen
            onFinish={onEmailStepFinished}
            callbackUrl={callbackUrl}
          />
        );
      case 'otp':
        return (
          <OtpVerification
            email={email}
            onFinish={handleOtpVerify}
            onChangeEmail={handleChangeEmail}
          />
        );
      case 'finished':
        return (
          <ChangePasswordScreen
            email={email}
            otp={otp}
            onFinish={() => {
              window.location.href = callbackUrl;
            }}
            onError={() => {
              setStep('OtpExpired');
            }}
          />
        );
      case 'OtpExpired':
        return (
          <ErrorScreen
            goBack={() => {
              setStep('initial');
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="signup-container">
      <Row className="signup-row" justify="center" align="middle">
        <Col className="form-col" xs={24} md={12} lg={12}>
          <div className="form-wrapper">
            <div className="form-header">
              <img src={FullLogo} alt="Bharat Carbon" className="logo" />
            </div>
            <div style={{marginTop: '30%'}}>{renderFormStep()}</div>
          </div>
        </Col>

        <Col className="right-col" xs={0} md={12} lg={12}>
          <div className="quote-block">
            <img src={QT66Img} alt="quote" className="earth-image" />
            <Title
              level={1}
              style={{
                color: '#607455',
                fontWeight: '400',
                marginTop: 0,
                marginBottom: 50,
                fontSize: 33
              }}
            >
              Your path to a cleaner and <br /> greener world starts here!
            </Title>
            <img
              src={GreenRightSideImg}
              alt="Greener Earth"
              className="earth-image"
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPasswordPage;
